import {SelectedSkinDataActionType} from "../Constants/SelectedSkinDataActionType";

export const setSelectedSkinDataAction = data => {
	return {
		type: SelectedSkinDataActionType.SET_SELECTED_SKIN_DATA,
		payload: data,
	};
};
